import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Avatar from '@/components-latest/primitives/Avatar'
import Separator from '@/components-latest/primitives/Separator'
import Text from '@/components-latest/primitives/Text'
import { BASE_URL } from '@/config/http/http'
import { selectCurrencySymbol } from '@/ducks/store/selectors/store.selectors'

import Styles from './ProductStatsCard.module.scss'

const composeImageLink = (relativeUrl: string) => {
  const paths = relativeUrl.split('/')
  return [`${BASE_URL}`, ...paths.slice(1)].join('/')
}

interface IProductStatsCardProps {
  count: number
  totalPrice: number
  item_id: string
  item_name: string
  avatar: string
}

const ProductStatsCard: React.FC<IProductStatsCardProps> = ({
  count,
  totalPrice,
  item_id,
  item_name,
  avatar
}) => {
  const { t } = useTranslation()
  const currencySymbol = useSelector(selectCurrencySymbol)

  return (
    <div
      className={Styles.productStatsCard}
      data-testid={`product-stats-card-${item_id}`}>
      <div className={clsx(Styles.header, Styles.content)}>
        <Avatar
          squared
          string={item_name}
          image={composeImageLink(avatar)}
          className={Styles.picture}
        />
        <Text variant="nextSubtitle" weight="bold">
          {item_name}
        </Text>
      </div>
      <div className={Styles.table}>
        <div className={clsx(Styles.cell, Styles.content)}>
          <Text variant="nextTitle-3">{count}</Text>
          <Text variant="nextBody">
            {t('performance.product-stats.items-sold')}
          </Text>
        </div>
        <Separator variant="solid" orientation="vertical" />
        <div className={clsx(Styles.cell, Styles.content)}>
          <Text variant="nextTitle-3">{`${totalPrice} ${currencySymbol}`}</Text>
          <Text variant="nextBody">
            {t('performance.product-stats.total-price')}
          </Text>
        </div>
      </div>
    </div>
  )
}

export default ProductStatsCard
